import select from 'dom-select';
import { mqMedium } from '../../../js/lib/breakpoints';

export const MenuToggle = (el) => {
  const header = el.closest('.global-header');

  const ui = {
    el,
    header,
    nav: header ? select('.global-header__menu', header) : null,
    body: select('body', document),
  };

  const desktopMq = window.matchMedia(mqMedium);

  const isOpen = () => ui.el.classList.contains('is-active');

  // Everything beside the header (skip link, main, footer) goes inert while
  // the menu is open, so Tab can't reach the page hidden behind it
  const setPageInert = (inert) => {
    const scope = ui.header?.parentElement;
    if (!scope) return;

    Array.from(scope.children).forEach((child) => {
      if (child !== ui.header) child.inert = inert;
    });
  };

  const setState = (open) => {
    ui.el.classList.toggle('is-active', open);
    ui.el.setAttribute('aria-expanded', String(open));

    if (ui.nav) {
      ui.nav.classList.toggle('is-active', open);
    }
    if (ui.body) {
      ui.body.classList.toggle('nav-open', open);
    }

    setPageInert(open);
  };

  const close = ({ returnFocus = false } = {}) => {
    if (!isOpen()) return;

    setState(false);

    if (returnFocus) {
      ui.el.focus();
    }
  };

  const handleKeydown = (event) => {
    if (event.key === 'Escape' && isOpen()) {
      event.preventDefault();
      close({ returnFocus: true });
    }
  };

  const handleBreakpoint = (event) => {
    // The toggle is hidden at medium+, so don't leave the page inert
    if (event.matches) close();
  };

  const addEvents = () => {
    ui.el.addEventListener('click', () => {
      setState(!isOpen());
    });

    document.addEventListener('keydown', handleKeydown);
    desktopMq.addEventListener('change', handleBreakpoint);
  }

  const init = () => {
    addEvents();
  };

  init();
};

export default MenuToggle;
